export const AGENT_EVENTS = {
  AI_SPEAK: "ai-speak",
  AI_THINKING: "AI_THINKING",
  AI_FINISH_THINKING: "AI_FINISH_THINKING",
  AI_LISTEN: "AI_LISTEN",
  AI_FINISH_SPEAK: "AI_FINISH_SPEAK",
  AI_ON_ENTER_PROXIMITY: "ai-proximity",
  AI_ON_LEAVE_PROXIMITY: "AI_ON_LEAVE_PROXIMITY",
  AI_TALKING_FRAME: "AI_TALKING"
};

export const AGENT_EVENTS_EDITOR = {
  ON_USER_ENTER: "user-enter",
  ON_USER_LEAVE: "user-leave",
  ON_AGENT_THINKING: "agent-thinking",
  ON_AGENT_TALK_START: "agent-talk-start",
  ON_AGENT_TALKING: "agent-talk-talking",
  ON_AGENT_TALK_END: "agent-talk-end"
};

export function gracefulChunkingWithLimit(text: string, maxWords = 60): string[] {
  const sentences = text.match(/[^.!?]+[.!?]?/g) || [text]; // Split text into sentences
  const chunks = [];
  let currentChunk: string[] = [];
  let currentWordCount = 0;

  for (const sentence of sentences) {
    const words = sentence.trim().split(/\s+/); // Split sentence into words
    const wordCount = words.length;

    // If adding this sentence exceeds the maxWords limit
    if (currentWordCount + wordCount > maxWords) {
      if (currentWordCount > 0) {
        // Push the current chunk if it is non-empty
        chunks.push(currentChunk.join(" "));
        currentChunk = [];
        currentWordCount = 0;
      }

      // If the sentence itself exceeds maxWords, split it
      if (wordCount > maxWords) {
        let tempChunk = [];
        for (const word of words) {
          if (tempChunk.length >= maxWords) {
            chunks.push(tempChunk.join(" "));
            tempChunk = [];
          }
          tempChunk.push(word);
        }
        if (tempChunk.length) {
          currentChunk = tempChunk;
          currentWordCount = tempChunk.length;
        }
        continue;
      }
    }

    // Add the sentence to the current chunk
    currentChunk.push(sentence.trim());
    currentWordCount += wordCount;

    // If the current chunk is full, finalize it
    if (currentWordCount >= maxWords) {
      chunks.push(currentChunk.join(" "));
      currentChunk = [];
      currentWordCount = 0;
    }
  }

  // Push the last chunk if it has remaining words
  if (currentChunk.length) {
    chunks.push(currentChunk.join(" "));
  }

  return chunks;
}
